import { render, staticRenderFns } from "./CourseGeneralEffectEffects.vue?vue&type=template&id=4f398932&scoped=true&"
import script from "./CourseGeneralEffectEffects.vue?vue&type=script&lang=js&"
export * from "./CourseGeneralEffectEffects.vue?vue&type=script&lang=js&"
import style0 from "./CourseGeneralEffectEffects.vue?vue&type=style&index=0&id=4f398932&scoped=true&lang=scss&"
import style1 from "./CourseGeneralEffectEffects.vue?vue&type=style&index=1&id=4f398932&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f398932",
  null
  
)

export default component.exports